var getVariant = variant => ({
  container: {
    border: "basic.".concat(variant === 'neutral' ? 'light' : variant),
    bgColor: 'neutral.white',
    color: 'neutral.black'
  }
});

export var sectionBannerTheme = {
  baseStyle: {
    container: {
      borderRadius: 'l',
      display: 'flex',
      p: 's',
      gridGap: 's',
      justifyContent: 'space-between',
      width: '100%',
      height: 'fit-content'
    },
    'inner-container': {
      display: 'flex',
      gridGap: 's'
    },
    'text-container': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      flex: 1,
      maxWidth: '720px',
      wordBreak: 'break-word'
    },
    title: {
      textStyle: 'body3Semi'
    },
    content: {
      textStyle: 'body3'
    }
  },
  variants: {
    neutral: getVariant('neutral'),
    info: getVariant('info'),
    success: getVariant('success'),
    warning: getVariant('warning'),
    critical: getVariant('critical')
  },
  defaultProps: {
    variant: 'info'
  }
};
//# sourceMappingURL=SectionBanner.theme.js.map